type BenefitWithType = { type: App.LuxPlusBenefitType }

/**
 * Puts benefits whose `type` appears in `priorityTypes` first, in that order.
 * Remaining benefits keep their relative order (stable).
 */
function orderLuxPlusBenefitsByPriority<T extends BenefitWithType>(
  benefits: Array<T>,
  priorityTypes?: Array<App.LuxPlusBenefitType>,
): Array<T> {
  if (!priorityTypes?.length) {
    return benefits
  }

  const rank = (t: App.LuxPlusBenefitType) => {
    const i = priorityTypes.indexOf(t)
    return i === -1 ? Number.MAX_SAFE_INTEGER : i
  }

  return benefits
    .map((benefit, index) => ({ benefit, index }))
    .sort((a, b) => {
      const diff = rank(a.benefit.type) - rank(b.benefit.type)
      if (diff !== 0) {
        return diff
      }
      return a.index - b.index
    })
    .map(({ benefit }) => benefit)
}

export default orderLuxPlusBenefitsByPriority
